import { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { richTextValidation } from 'validators';
import { TextField, TextButton } from 'seagull';
import { jsx as _jsx } from "react/jsx-runtime";
export default function BillingItemNote(props) {
  const {
    control,
    getValues
  } = useFormContext();
  const {
    testid
  } = props;
  const [isAddingNote, setIsAddingNote] = useState(false);
  const [initialNote] = useState(getValues(props.name));
  return isAddingNote || !!initialNote ? /*#__PURE__*/_jsx(Controller, {
    control: control,
    name: props.name,
    rules: richTextValidation('Note'),
    render: _ref => {
      let {
        field: {
          value,
          ref,
          onChange,
          onBlur
        },
        fieldState: {
          isTouched,
          isDirty,
          error
        }
      } = _ref;
      return /*#__PURE__*/_jsx(TextField, {
        multiline: true,
        width: 500,
        label: "Notes (optional)",
        minRows: 3,
        maxRows: 3,
        testid: testid,
        error: isTouched && !!error,
        helperText: isTouched && error && error.message,
        value: value,
        inputRef: element => {
          ref(element);
          if (element && initialNote && !isDirty) {
            // Set the cursor to the end of the note
            element.setSelectionRange(initialNote.length, initialNote.length);
          }
        },
        onChange: onChange,
        onBlur: onBlur
      });
    }
  }) : /*#__PURE__*/_jsx(TextButton, {
    underline: "none",
    "data-testid": testid && "".concat(testid, "-add-note"),
    onClick: () => setIsAddingNote(true),
    children: "+ Add Note"
  });
}